import { render, staticRenderFns } from "./verAddModel.vue?vue&type=template&id=25106e20&scoped=true&"
import script from "./verAddModel.vue?vue&type=script&lang=js&"
export * from "./verAddModel.vue?vue&type=script&lang=js&"
import style0 from "./verAddModel.vue?vue&type=style&index=0&id=25106e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25106e20",
  null
  
)

export default component.exports